import React from "react";
import { FaIcon } from "../../common/Icons.jsx";
import Select from "../../common/Select.jsx";
import { Mode } from "../common.jsx";
import Setting from './setting.jsx';

import AdaliaMEDatagridBase from './adalia_me_datagrid_base.jsx';
import { formatNumber } from '../../common/FormattedNumber.jsx';
import DatagridEditDialog from "../../datagrid/DatagridDialog.jsx"

import { financial_datagrid_list_json_path } from '~/routes';

export default class AdaliaMEFinancialDatagrid extends AdaliaMEDatagridBase {
    static get TYPE() {
        return "adalia_me_financial_datagrid";
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.pdf) return;

        jQuery.getJSON(financial_datagrid_list_json_path({programme_form_id: this.context.programmeFormId, _options: true}), (data) => {
          this.setState({
            datagrids: data,
            context_name: 'financial_datagrid'
          })
        });
    }

    calculateSum = () => {
        const accessor = this.getColumns().find(a => a.id == this.props.content.sumCol)?.accessor;
        if (!accessor) return 0;
    
        return JSON.parse(this.getRawAnswer() || '[]').reduce((total, row) => total + (row?.[accessor] || 0), 0)
    }

    renderView() {
        if (this.props.pdf){
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
            <label>
              {this.getText("label")}
            </label>
            {this.descriptionText()}
            <div className='non-printable-component text-muted'>{I18n.t('non_printable_component_placeholder')}</div>
            </div>
          )
        }
    
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
              <span className="field-label">{this.getText('label')}</span>
            </label>
            {this.descriptionText()}
            {[Mode.FILL, Mode.EDIT].includes(this.props.mode) && 
              <div 
                className='border-dashed dark-bg d-flex align-items-center gap-1 p-1 text-color-light flex-dir-column cursor-pointer' 
                onClick = {(e) => { this.toggleModalVisibility(true) }}
              >
                <FaIcon type='table' style={{fontSize: '3rem', color: 'rgba(0,0,0,0.3)'}}/>
                <span>
                  {I18n.t('modify_grid', {scope: 'fe'})}
                </span>
              </div>
            }
            
            <div className='d-flex justify-content flex-dir-column rounded p-1 mt-1' style={{ border: '2px solid rgba(0, 0, 0, 0.2)' }}
              onClick = {(e) => { e.preventDefault();this.toggleModalVisibility(true) }}
            >
              <div className='d-flex justify-content gap-1'>
                {this.props.content.sumCol && <span className='text-bold'>{`${I18n.t('total')}: ${formatNumber(this.calculateSum())}`}</span>}
                <span>{JSON.parse(this.getRawAnswer() || '[]').length + ' ' + I18n.t('rows_defined', {scope: 'fe'})}</span>
              </div>
              {this.props.mode == Mode.VIEW && <a href='#'>{I18n.t('click_to_view')}</a>}
            </div>
            {this.state.showModal ? (
              <DatagridEditDialog
                title={this.getText('label')}
                onClose={this.toggleModalVisibility}
                onSave={this.onSave}
                editable={[Mode.FILL, Mode.EDIT].includes(this.props.mode)}
                saveText={I18n.t('save')}
                datagridID={this.props.content.selectedDatagrid}
                visibleCols={this.props.content.visibleCols}
                rowData={this.getRawAnswer() ? JSON.parse(this.getRawAnswer()) : this.getRawAnswer()}
                contextName={this.state.context_name}
                queryParams={{programme_form_id: this.context.programmeFormId}}
               />
            ) : null}
            <input type="hidden" value={this.getRawAnswer()} name={this.fullFieldName()} />
          </div>
        );
    }

    renderSettings() {
        const { selectedDatagrid, visibleCols, sumCol } = this.props.content
        const { datagrids } = this.state
        const allColumns = this.getColumns();
    
        return (
          <div>
            <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText("label")} onChange={this.updateSettings} />
            <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
            <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText("description")} onChange={this.updateSettings} />
            <Setting.TextField
              name="reportKey"
              label={I18n.t('field_report_key', {scope: 'fe'})}
              value={this.props.content.reportKey}
              description={I18n.t('field_report_key_description', {scope: 'fe'})}
              componentType={this.constructor.TYPE}
              {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
            />
            {datagrids.length && (<><Setting.Dropdown 
                name="selectedDatagrid" 
                label={I18n.t('field_selected_datagrid', {scope: 'fe'})} 
                value={selectedDatagrid?.toString()} 
                onChange={this.updateSettings} 
                options={datagrids.map( d => [d.id, d.name] )}
            />
            <label className="w-100 mt-1">{I18n.t('field_datagrid_visible_cols', {scope: 'fe'})}</label>
            <Select
              name="visibleCols"
              defaultValue={allColumns.map(c => c.id)}
              value={visibleCols}
              isMulti={true}
              options={allColumns}
              onChange={(e) => this.updateSettingsSelection('visibleCols', e)}
              description={I18n.t('field_visible_columns_description', {scope: 'fe'})}
              autoComplete={this.getAutoComplete()}
            />
            
            <label className="w-100 mt-1">{I18n.t('field_datagrid_display_sum_for', {scope: 'fe'})}</label>
            <Select
              name="sumCol"
              value={sumCol}
              options={allColumns.filter(a => visibleCols.includes(a.value) && ['integer', 'decimal'].includes(a.column_type))}
              onChange={(e) => this.updateSettingsSelection('sumCol', e)}
              description={I18n.t('field_datagrid_display_sum_for_description', {scope: 'fe'})}
              autoComplete={this.getAutoComplete()}
            />
            </>)}
          </div>
        );
    }
}